import messages from './cmsHomeCard.json' with { type: 'json' };

export const cmsHomeCardEn: Readonly<typeof messages> = messages;
